// extracted by mini-css-extract-plugin
export default {"zoomControls":"kca-z","zoomControlButton":"lca-z","zoomBanner":"mca-z","bannerButton":"nca-z","imageButton":"oca-z","zoom":"pca-z","zoomContent":"qca-z"};